var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlibaba(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-4cabcc94-b007-422f-b6a3-dfa0676da496",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .uuid-2031fb46-87b9-42fd-b9fd-dbdeaec7942c {\n        fill: #f2f2f2;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "uuid-2031fb46-87b9-42fd-b9fd-dbdeaec7942c",
    d: "M18.86,16.62h-5.72v-1.29h5.72v1.29ZM21.72,10.65h-3.78l.91,1.29,2.76.85c.49.16.83.61.83,1.14h0s0,0,0,0v4.14h0c0,.54-.35.99-.82,1.14h0s-2.76.85-2.76.85l-.91,1.29h3.78c1.58,0,2.86-1.28,2.86-2.86h0v-4.99c0-1.58-1.28-2.86-2.86-2.86h0ZM10.28,10.65h3.78l-.91,1.29-2.76.85c-.49.16-.83.61-.83,1.14h0s0,0,0,0v4.14h0c0,.54.35.99.82,1.14h0s2.76.85,2.76.85l.91,1.29h-3.78c-1.58,0-2.86-1.28-2.86-2.86h0v-4.99c0-1.58,1.28-2.86,2.86-2.86h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlibaba);
export default __webpack_public_path__ + "static/media/Alibaba.255480ccb71eed38ab0693f073a3c061.svg";
export { ForwardRef as ReactComponent };